module.exports = __webpack_public_path__ + "static/img/4.舊衣募集2025.ed60d69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/charitable-activities/4.舊衣募集2025.jpg
// module id = 9meL
// module chunks = 98